import { render, staticRenderFns } from "./adminNarcotics.vue?vue&type=template&id=f51501a2"
import script from "./adminNarcotics.vue?vue&type=script&lang=js"
export * from "./adminNarcotics.vue?vue&type=script&lang=js"
import style0 from "./adminNarcotics.vue?vue&type=style&index=0&id=f51501a2&prod&lang=css"
import style1 from "./adminNarcotics.vue?vue&type=style&index=1&id=f51501a2&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports